export default "__VITE_PUBLIC_ASSET__9fe0becf__"